import { useContext, useEffect, useState } from "react";
import { LocaleContext } from "../../state/LocaleContext.js";

export default function LocaleSelector() {
  const { locale, setLocale, translations } = useContext(LocaleContext);
  const [locales, setLocales] = useState([]);

  useEffect(() => {
    fetch("/api/locales")
      .then((res) => res.json())
      .then((data) => setLocales(data.rows || []))
      .catch((err) => console.error("failed to load locales", err));
  }, []);

  const getLabel = (l) => {
    if (!l?.id) return "";
    const key = `locales:${l.id}:name`;
    return translations[key] || l.name; // translation first, fallback to DB name
  };

  return (
    <li className="nav-item mx-3 mx-md-2 dropdown">
      <a
        className="nav-link dropdown-toggle"
        href="#"
        id="localeDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span className="d-inline d-md-none d-xl-inline">{getLabel(locales.find((l) => l.locale_code === locale) || {})}</span> <i className="bi bi-translate d-none d-md-inline d-xl-none"></i>
      </a>
      <ul className="dropdown-menu" aria-labelledby="localeDropdown">
        {locales.map((l) => (
          <li key={l.locale_code}>
            <a
              className="dropdown-item"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setLocale(l.locale_code); // updates global context
              }}
            >
              {getLabel(l)}
            </a>
          </li>
        ))}
      </ul>
    </li>
  );
}
